export class LoginApiResponseModel {
    message: string;
    success: boolean;
    data: LoginApiDataModel;
}

export class LoginApiDataModel {
    uuid: string;
    firstName: string;
    lastName: string;
    role: string;
    token: string;
    phone: string;
    email: string;
    gender: string;
    plan: string;
    userName: string;
    givenName: string;
    domain_name: string;
    entity_id: string;
    isDeleted: number;
    session_id: string;


    constructor(obj?) {
        if (obj) {
            this.uuid = obj.uuid;
            this.firstName = obj.first_name;
            this.lastName = obj.last_name;
            this.role = obj.role;
            this.token = obj.token;
            this.phone = obj.phone;
            this.email = obj.email;
            this.gender = obj.gender;
            this.userName = obj.userName;
            this.plan = obj.plan;
            this.givenName = obj.givenName;
            this.domain_name = obj.domain_name;
            this.isDeleted = obj.isDeleted;
        }
    }
}